import React from "react";

const ProfileIcon = ({ color = "#122549" }) => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1C6.3724 1 1 6.3724 1 13C1 19.6276 6.3724 25 13 25C19.6276 25 25 19.6276 25 13C25 6.3724 19.6276 1 13 1Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.7251 20.6153C3.7251 20.6153 6.3999 17.2 12.9999 17.2C19.5999 17.2 22.2759 20.6153 22.2759 20.6153M12.9999 13C13.9547 13 14.8704 12.6208 15.5455 11.9456C16.2206 11.2705 16.5999 10.3548 16.5999 9.40005C16.5999 8.44527 16.2206 7.5296 15.5455 6.85446C14.8704 6.17933 13.9547 5.80005 12.9999 5.80005C12.0451 5.80005 11.1294 6.17933 10.4543 6.85446C9.77918 7.5296 9.3999 8.44527 9.3999 9.40005C9.3999 10.3548 9.77918 11.2705 10.4543 11.9456C11.1294 12.6208 12.0451 13 12.9999 13Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ProfileIcon;
